module.exports = __webpack_public_path__ + "img/friendlydragonthumb.d3f99221.gif";